// This file is auto-generated by @hey-api/openapi-ts

import { type Client, formDataBodySerializer, type Options as Options2, type TDataShape, urlSearchParamsBodySerializer } from './client';
import { client } from './client.gen';
import type { AcceptAgreementData, AcceptAgreementErrors, AcceptAgreementResponses, ActionsAdminAgreementData, ActionsAdminAgreementErrors, ActionsAdminAgreementResponses, AddArtifactAdminDisputeData, AddArtifactAdminDisputeErrors, AddArtifactAdminDisputeResponses, ApproveAdminKycData, ApproveAdminKycErrors, ApproveAdminKycResponses, ArchiveAgreementData, ArchiveAgreementErrors, ArchiveAgreementResponses, ByAgreementDisputeData, ByAgreementDisputeErrors, ByAgreementDisputeResponses, CancelAdminAgreementData, CancelAdminAgreementErrors, CancelAdminAgreementResponses, CancelAgreementData, CancelAgreementErrors, CancelAgreementResponses, CancelMsisdnChangeData, CancelMsisdnChangeErrors, CancelMsisdnChangeResponses, CardContactData, CardContactErrors, CardContactResponses, CardOtpPaymentData, CardOtpPaymentErrors, CardOtpPaymentResponses, CheckUzumData, CheckUzumErrors, CheckUzumResponses, CompleteClickData, CompleteClickResponses, ConfigAgreementData, ConfigAgreementErrors, ConfigAgreementResponses, ConfigAppConfigData, ConfigAppConfigErrors, ConfigAppConfigResponses, ConfirmDisbursementTransferData, ConfirmDisbursementTransferErrors, ConfirmDisbursementTransferResponses, ConfirmKycAdminDeviceData, ConfirmKycAdminDeviceErrors, ConfirmKycAdminDeviceResponses, ConfirmOldMsisdnChangeData, ConfirmOldMsisdnChangeErrors, ConfirmOldMsisdnChangeResponses, ConfirmPaymentData, ConfirmPaymentErrors, ConfirmPaymentInstallmentData, ConfirmPaymentInstallmentErrors, ConfirmPaymentInstallmentResponses, ConfirmPaymentResponses, ConfirmRepaymentTransferData, ConfirmRepaymentTransferErrors, ConfirmRepaymentTransferResponses, ConfirmUzumData, ConfirmUzumErrors, ConfirmUzumResponses, ContestMsisdnChangeData, ContestMsisdnChangeErrors, ContestMsisdnChangeResponses, CreateAdminBlacklistData, CreateAdminBlacklistErrors, CreateAdminBlacklistResponses, CreateAdminRoleData, CreateAdminRoleErrors, CreateAdminRoleResponses, CreateAdminUserData, CreateAdminUserErrors, CreateAdminUserResponses, CreateAgreementData, CreateAgreementErrors, CreateAgreementResponses, CreateMsisdnChangeData, CreateMsisdnChangeErrors, CreateMsisdnChangeResponses, CreateSessionDeviceConfirmationData, CreateSessionDeviceConfirmationErrors, CreateSessionDeviceConfirmationResponses, CreateSessionKycData, CreateSessionKycErrors, CreateSessionKycResponses, CreateUzumData, CreateUzumErrors, CreateUzumResponses, CurrentFileOfferData, CurrentFileOfferErrors, CurrentFileOfferResponses, CurrentOfferData, CurrentOfferErrors, CurrentOfferResponses, DeclineAgreementData, DeclineAgreementErrors, DeclineAgreementResponses, DeclineSignContractData, DeclineSignContractErrors, DeclineSignContractResponses, DeleteAdminBlacklistData, DeleteAdminBlacklistErrors, DeleteAdminBlacklistResponses, DeleteAdminRoleData, DeleteAdminRoleErrors, DeleteAdminRoleResponses, DeleteAgreementData, DeleteAgreementErrors, DeleteAgreementResponses, EvidenceByAgreementAdminDisputeData, EvidenceByAgreementAdminDisputeErrors, EvidenceByAgreementAdminDisputeResponses, EvidenceByDisputeAdminDisputeData, EvidenceByDisputeAdminDisputeErrors, EvidenceByDisputeAdminDisputeResponses, FeeQuoteAgreementData, FeeQuoteAgreementErrors, FeeQuoteAgreementResponses, FileDocumentData, FileDocumentErrors, FileDocumentResponses, GenerateContractData, GenerateContractErrors, GenerateContractResponses, GetAdminUserData, GetAdminUserErrors, GetAdminUserResponses, GetAgreementData, GetAgreementErrors, GetAgreementResponses, GetAvatarData, GetAvatarErrors, GetAvatarResponses, GetContractData, GetContractErrors, GetContractResponses, GetDisputeData, GetDisputeErrors, GetDisputeResponses, GetDocumentData, GetDocumentErrors, GetDocumentResponses, GetMsisdnChangeData, GetMsisdnChangeErrors, GetMsisdnChangeResponses, GetPaymentData, GetPaymentErrors, GetPaymentResponses, InitiatePaymentData, InitiatePaymentErrors, InitiatePaymentResponses, InviteContactData, InviteContactErrors, InviteContactResponses, InviteLinkContactData, InviteLinkContactErrors, InviteLinkContactResponses, KycReverifyMsisdnChangeData, KycReverifyMsisdnChangeErrors, KycReverifyMsisdnChangeResponses, ListAdminBlacklistData, ListAdminBlacklistErrors, ListAdminBlacklistResponses, ListAdminKycData, ListAdminKycErrors, ListAdminKycResponses, ListAdminPermissionData, ListAdminPermissionErrors, ListAdminPermissionResponses, ListAdminRoleData, ListAdminRoleErrors, ListAdminRoleResponses, ListAdminUserData, ListAdminUserErrors, ListAdminUserResponses, ListAgreementData, ListAgreementErrors, ListAgreementResponses, ListAuditData, ListAuditErrors, ListAuditResponses, ListDeviceData, ListDeviceErrors, ListDeviceResponses, ListDevicesAdminDeviceData, ListDevicesAdminDeviceErrors, ListDevicesAdminDeviceResponses, ListFeeTariffData, ListFeeTariffErrors, ListFeeTariffResponses, ListMineOfferAcceptanceData, ListMineOfferAcceptanceErrors, ListMineOfferAcceptanceResponses, ListNotificationData, ListNotificationErrors, ListNotificationResponses, ListSettingsData, ListSettingsErrors, ListSettingsResponses, LogoutAuthData, LogoutAuthErrors, LogoutAuthResponses, MarkAllReadNotificationData, MarkAllReadNotificationErrors, MarkAllReadNotificationResponses, MarkReadNotificationData, MarkReadNotificationErrors, MarkReadNotificationResponses, MatchContactData, MatchContactErrors, MatchContactResponses, MeProfileData, MeProfileErrors, MeProfileResponses, MetricsAdminMetricsData, MetricsAdminMetricsErrors, MetricsAdminMetricsResponses, MeUserData, MeUserErrors, MeUserResponses, OpenDisputeData, OpenDisputeErrors, OpenDisputeResponses, OverrideAdminKycData, OverrideAdminKycErrors, OverrideAdminKycResponses, PdfContractData, PdfContractErrors, PdfContractResponses, PrepareClickData, PrepareClickResponses, PreviewContractData, PreviewContractErrors, PreviewContractResponses, ProofTransferData, ProofTransferErrors, ProofTransferResponses, PublishAdminDocumentData, PublishAdminDocumentErrors, PublishAdminDocumentResponses, PublishAdminOfferData, PublishAdminOfferErrors, PublishAdminOfferResponses, RatingInfoProfileData, RatingInfoProfileErrors, RatingInfoProfileResponses, ReceiptNotificationReceiptData, ReceiptNotificationReceiptErrors, ReceiptNotificationReceiptResponses, RecoverKycData, RecoverKycErrors, RecoverKycResponses, RefreshAuthData, RefreshAuthErrors, RefreshAuthResponses, RefundAdminPaymentData, RefundAdminPaymentErrors, RefundAdminPaymentResponses, RejectAdminKycData, RejectAdminKycErrors, RejectAdminKycResponses, RemoveAvatarAdminUserData, RemoveAvatarAdminUserErrors, RemoveAvatarAdminUserResponses, RemoveAvatarProfileData, RemoveAvatarProfileErrors, RemoveAvatarProfileResponses, ReplaceFeeTariffData, ReplaceFeeTariffErrors, ReplaceFeeTariffResponses, ReplacePermissionsAdminRoleData, ReplacePermissionsAdminRoleErrors, ReplacePermissionsAdminRoleResponses, ReplaceRolesAdminUserData, ReplaceRolesAdminUserErrors, ReplaceRolesAdminUserResponses, RequestOtpAuthData, RequestOtpAuthErrors, RequestOtpAuthResponses, ResignContractData, ResignContractErrors, ResignContractResponses, ResignStatusContractData, ResignStatusContractErrors, ResignStatusContractResponses, ResolveAdminMsisdnChangeData, ResolveAdminMsisdnChangeErrors, ResolveAdminMsisdnChangeResponses, RestructureAgreementData, RestructureAgreementErrors, RestructureAgreementResponses, ReverseUzumData, ReverseUzumErrors, ReverseUzumResponses, RevokeDeviceData, RevokeDeviceErrors, RevokeDeviceResponses, RpcPaynetData, RpcPaynetErrors, RpcPaynetResponses, RunScoringData, RunScoringErrors, RunScoringResponses, ScheduleInstallmentData, ScheduleInstallmentErrors, ScheduleInstallmentResponses, SearchAdminAgreementData, SearchAdminAgreementErrors, SearchAdminAgreementResponses, SearchAdminPaymentData, SearchAdminPaymentErrors, SearchAdminPaymentResponses, SendAgreementData, SendAgreementErrors, SendAgreementResponses, SignContractData, SignContractErrors, SignContractResponses, SignSessionContractData, SignSessionContractErrors, SignSessionContractResponses, StatusesAgreementData, StatusesAgreementErrors, StatusesAgreementResponses, StatusKycData, StatusKycErrors, StatusKycResponses, StatusUzumData, StatusUzumErrors, StatusUzumResponses, SubmitKycData, SubmitKycErrors, SubmitKycResponses, SubmitResultDeviceConfirmationData, SubmitResultDeviceConfirmationErrors, SubmitResultDeviceConfirmationResponses, SubmitResultKycData, SubmitResultKycErrors, SubmitResultKycResponses, TotalsAgreementData, TotalsAgreementErrors, TotalsAgreementResponses, TransfersTransferData, TransfersTransferErrors, TransfersTransferResponses, TransitionAdminDisputeData, TransitionAdminDisputeErrors, TransitionAdminDisputeResponses, UnarchiveAgreementData, UnarchiveAgreementErrors, UnarchiveAgreementResponses, UpdateAdminRoleData, UpdateAdminRoleErrors, UpdateAdminRoleResponses, UpdatePushTokenDeviceData, UpdatePushTokenDeviceErrors, UpdatePushTokenDeviceResponses, UpdateSettingsData, UpdateSettingsErrors, UpdateSettingsResponses, UpdateSettingsUserData, UpdateSettingsUserErrors, UpdateSettingsUserResponses, UpdateStatusAdminUserData, UpdateStatusAdminUserErrors, UpdateStatusAdminUserResponses, UploadAvatarProfileData, UploadAvatarProfileErrors, UploadAvatarProfileResponses, UploadProofInstallmentData, UploadProofInstallmentErrors, UploadProofInstallmentResponses, UploadProofTransferData, UploadProofTransferErrors, UploadProofTransferResponses, VerifyNewMsisdnChangeData, VerifyNewMsisdnChangeErrors, VerifyNewMsisdnChangeResponses, VerifyOtpAuthData, VerifyOtpAuthErrors, VerifyOtpAuthResponses, VersionFileOfferAcceptanceData, VersionFileOfferAcceptanceErrors, VersionFileOfferAcceptanceResponses, WebhookPaymentData, WebhookPaymentErrors, WebhookPaymentResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean, TResponse = unknown> = Options2<TData, ThrowOnError, TResponse> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

/**
 * Удалить аватар
 *
 * Убирает аватар из профиля и удаляет файл. Идемпотентно. Требует право profile.write.
 */
export const removeAvatarProfile = <ThrowOnError extends boolean = false>(options?: Options<RemoveAvatarProfileData, ThrowOnError>) => (options?.client ?? client).delete<RemoveAvatarProfileResponses, RemoveAvatarProfileErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/users/me/profile/avatar',
    ...options
});

/**
 * Загрузить аватар
 *
 * Принимает JPEG или PNG до profile.avatar.max.size.bytes, перекодирует в квадратный JPEG (profile.avatar.side.px, метаданные снимаются) и сохраняет; прежний аватар удаляется. Картинка — GET /api/avatars/{avatarFileId}. Требует право profile.write.
 */
export const uploadAvatarProfile = <ThrowOnError extends boolean = false>(options?: Options<UploadAvatarProfileData, ThrowOnError>) => (options?.client ?? client).put<UploadAvatarProfileResponses, UploadAvatarProfileErrors, ThrowOnError>({
    ...formDataBodySerializer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/users/me/profile/avatar',
    ...options,
    headers: {
        'Content-Type': null,
        ...options?.headers
    }
});

/**
 * Сохранение push-токена устройства
 *
 * Привязывает push-токен (FCM) к устройству. Можно обновлять только свои устройства. Требует право device.read.
 */
export const updatePushTokenDevice = <ThrowOnError extends boolean = false>(options: Options<UpdatePushTokenDeviceData, ThrowOnError>) => (options.client ?? client).put<UpdatePushTokenDeviceResponses, UpdatePushTokenDeviceErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/users/me/devices/{id}/push-token',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Заменить роли пользователя
 *
 * Полностью заменяет набор ролей пользователя на указанный (replace, не append). Пустой набор запрещён. Изменение действует немедленно. Требует право users.roles.write.
 */
export const replaceRolesAdminUser = <ThrowOnError extends boolean = false>(options: Options<ReplaceRolesAdminUserData, ThrowOnError>) => (options.client ?? client).put<ReplaceRolesAdminUserResponses, ReplaceRolesAdminUserErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/users/{id}/roles',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Обновить значение настройки
 *
 * Валидирует новое значение по SettingType, сохраняет, проставляет updatedBy = текущий пользователь, инвалидирует кэш. Требует право settings.write.
 */
export const updateSettings = <ThrowOnError extends boolean = false>(options: Options<UpdateSettingsData, ThrowOnError>) => (options.client ?? client).put<UpdateSettingsResponses, UpdateSettingsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/settings/{key}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Удалить роль
 *
 * Удаляет роль вместе с её привязками к правам. Запрещено, если роль ещё назначена хотя бы одному пользователю (409 ROLE_IN_USE). Требует право roles.write.
 */
export const deleteAdminRole = <ThrowOnError extends boolean = false>(options: Options<DeleteAdminRoleData, ThrowOnError>) => (options.client ?? client).delete<DeleteAdminRoleResponses, DeleteAdminRoleErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/roles/{id}',
    ...options
});

/**
 * Редактировать роль
 *
 * Обновляет имя и описание роли. Набор прав не меняется — для этого PUT /api/admin/roles/{id}/permissions. Требует право roles.write.
 */
export const updateAdminRole = <ThrowOnError extends boolean = false>(options: Options<UpdateAdminRoleData, ThrowOnError>) => (options.client ?? client).put<UpdateAdminRoleResponses, UpdateAdminRoleErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/roles/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Заменить набор прав у роли
 *
 * Полностью заменяет набор прав роли на указанный (replace, не append). Пустой набор допустим. Изменение действует немедленно. Требует право roles.write.
 */
export const replacePermissionsAdminRole = <ThrowOnError extends boolean = false>(options: Options<ReplacePermissionsAdminRoleData, ThrowOnError>) => (options.client ?? client).put<ReplacePermissionsAdminRoleResponses, ReplacePermissionsAdminRoleErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/roles/{id}/permissions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Тарифная сетка service fee
 *
 * Возвращает все строки сетки (тип договора, диапазон суммы в тийинах, комиссия), отсортированные по типу и нижней границе. Требует право settings.read.
 */
export const listFeeTariff = <ThrowOnError extends boolean = false>(options?: Options<ListFeeTariffData, ThrowOnError>) => (options?.client ?? client).get<ListFeeTariffResponses, ListFeeTariffErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/fee-tariffs',
    ...options
});

/**
 * Заменить тарифную сетку service fee
 *
 * Атомарно заменяет всю сетку. По каждому типу договора диапазоны обязаны начинаться с 0 и покрывать суммы сплошняком, без дыр и перекрытий (следующий min = предыдущий max + 1). Требует право settings.write.
 */
export const replaceFeeTariff = <ThrowOnError extends boolean = false>(options: Options<ReplaceFeeTariffData, ThrowOnError>) => (options.client ?? client).put<ReplaceFeeTariffResponses, ReplaceFeeTariffErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/fee-tariffs',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Отметить уведомление прочитанным
 *
 * Переводит уведомление в READ и проставляет read_at. Идемпотентно. Можно отмечать только свои уведомления. Требует право notification.mark_read.
 */
export const markReadNotification = <ThrowOnError extends boolean = false>(options: Options<MarkReadNotificationData, ThrowOnError>) => (options.client ?? client).post<MarkReadNotificationResponses, MarkReadNotificationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/users/me/notifications/{id}/read',
    ...options
});

/**
 * Отметить все уведомления прочитанными
 *
 * Переводит все непрочитанные уведомления текущего пользователя в READ. Требует право notification.mark_read.
 */
export const markAllReadNotification = <ThrowOnError extends boolean = false>(options?: Options<MarkAllReadNotificationData, ThrowOnError>) => (options?.client ?? client).post<MarkAllReadNotificationResponses, MarkAllReadNotificationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/users/me/notifications/read-all',
    ...options
});

/**
 * Инициировать смену номера
 *
 * Создаёт запрос смены MSISDN (INITIATED) и отправляет OTP на новый номер. Новый номер не должен быть занят; не более одного активного запроса; лимит смен за 12 месяцев. Идемпотентно по Idempotency-Key. Требует право msisdn.change.
 */
export const createMsisdnChange = <ThrowOnError extends boolean = false>(options: Options<CreateMsisdnChangeData, ThrowOnError>) => (options.client ?? client).post<CreateMsisdnChangeResponses, CreateMsisdnChangeErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/users/me/msisdn-changes',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Подтвердить новый номер
 *
 * Проверяет OTP нового номера (INITIATED→NEW_VERIFIED); при доступном старом номере отправляет OTP на него. Идемпотентно по Idempotency-Key. Требует право msisdn.change.
 */
export const verifyNewMsisdnChange = <ThrowOnError extends boolean = false>(options: Options<VerifyNewMsisdnChangeData, ThrowOnError>) => (options.client ?? client).post<VerifyNewMsisdnChangeResponses, VerifyNewMsisdnChangeErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/users/me/msisdn-changes/{id}/verify-new',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * KYC-реверификация (утраченный номер)
 *
 * Полная реверификация личности через активного KYC-провайдера; ПИНФЛ должен совпасть с текущим (NEW_VERIFIED→IDENTITY_CONFIRMED), таймер возражения расширенный. Идемпотентно по Idempotency-Key. Требует право msisdn.change.
 */
export const kycReverifyMsisdnChange = <ThrowOnError extends boolean = false>(options: Options<KycReverifyMsisdnChangeData, ThrowOnError>) => (options.client ?? client).post<KycReverifyMsisdnChangeResponses, KycReverifyMsisdnChangeErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/users/me/msisdn-changes/{id}/kyc-reverify',
    ...options
});

/**
 * Подтвердить старый номер
 *
 * Проверяет OTP старого номера и strong confirmation (NEW_VERIFIED→IDENTITY_CONFIRMED), классифицирует затронутые договоры, замораживает чувствительные действия, уведомляет контрагентов и запускает таймер возражения (PARTIES_NOTIFIED). Идемпотентно по Idempotency-Key. Требует право msisdn.change.
 */
export const confirmOldMsisdnChange = <ThrowOnError extends boolean = false>(options: Options<ConfirmOldMsisdnChangeData, ThrowOnError>) => (options.client ?? client).post<ConfirmOldMsisdnChangeResponses, ConfirmOldMsisdnChangeErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/users/me/msisdn-changes/{id}/confirm-old',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Статус KYC
 *
 * Возвращает статус идентификации и сводку последней заявки. Требует право kyc.status.read.
 */
export const statusKyc = <ThrowOnError extends boolean = false>(options?: Options<StatusKycData, ThrowOnError>) => (options?.client ?? client).get<StatusKycResponses, StatusKycErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/users/me/kyc',
    ...options
});

/**
 * Инициировать KYC
 *
 * Дёргает активного KYC-провайдера. При успехе выставляет VERIFIED; при отказе — учитывает попытку и после лимита переводит в ручную верификацию. Требует право kyc.submit.
 */
export const submitKyc = <ThrowOnError extends boolean = false>(options?: Options<SubmitKycData, ThrowOnError>) => (options?.client ?? client).post<SubmitKycResponses, SubmitKycErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/users/me/kyc',
    ...options
});

/**
 * Создать MyID-сессию
 *
 * Создаёт сессию идентификации в MyID по ПИНФЛ (дата рождения извлекается из него), паспорту (pass_data, birthDate обязательна) или без документа — тогда SDK сам показывает экран ввода. Указывать и pinfl, и passData одновременно нельзя. Возвращает sessionId + clientHash/clientHashId для мобильного SDK. Доступно при активном настроенном MyID-провайдере. Требует право kyc.submit.
 */
export const createSessionKyc = <ThrowOnError extends boolean = false>(options: Options<CreateSessionKycData, ThrowOnError>) => (options.client ?? client).post<CreateSessionKycResponses, CreateSessionKycErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/users/me/kyc/session',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Принять результат MyID
 *
 * Обменивает code из мобильного SDK у MyID на данные пользователя. При успехе выставляет VERIFIED; при отказе — учитывает попытку и после лимита переводит в ручную верификацию. Доступно при активном настроенном MyID-провайдере. Требует право kyc.submit.
 */
export const submitResultKyc = <ThrowOnError extends boolean = false>(options: Options<SubmitResultKycData, ThrowOnError>) => (options.client ?? client).post<SubmitResultKycResponses, SubmitResultKycErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/users/me/kyc/result',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Восстановить результат MyID
 *
 * Забирает потерянный code из статуса последней MyID-сессии пользователя и обменивает его как обычный результат. 404 KYC_MYID_NO_SESSION, если недавней сессии нет или в ней нет готового code. Доступно при активном настроенном MyID-провайдере. Требует право kyc.submit.
 */
export const recoverKyc = <ThrowOnError extends boolean = false>(options?: Options<RecoverKycData, ThrowOnError>) => (options?.client ?? client).post<RecoverKycResponses, RecoverKycErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/users/me/kyc/recover',
    ...options
});

/**
 * Создать MyID-сессию подтверждения устройства
 *
 * Создаёт liveness-сессию по reuid последней идентификации (без ввода документа), при его отсутствии — по ПИНФЛ профиля. Возвращает sessionId + clientHash/clientHashId для мобильного SDK. Доступно при активном настроенном MyID-провайдере. Требует право kyc.submit.
 */
export const createSessionDeviceConfirmation = <ThrowOnError extends boolean = false>(options?: Options<CreateSessionDeviceConfirmationData, ThrowOnError>) => (options?.client ?? client).post<CreateSessionDeviceConfirmationResponses, CreateSessionDeviceConfirmationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/users/me/devices/confirmation/session',
    ...options
});

/**
 * Подтвердить устройство результатом MyID
 *
 * Обменивает code из мобильного SDK и сверяет личность с владельцем аккаунта (ПИНФЛ, для reuid-обмена — серия/номер документа). Совпадение подтверждает устройство; несовпадение учитывается как попытка, после 3 попыток устройство отзывается. Требует право kyc.submit.
 */
export const submitResultDeviceConfirmation = <ThrowOnError extends boolean = false>(options: Options<SubmitResultDeviceConfirmationData, ThrowOnError>) => (options.client ?? client).post<SubmitResultDeviceConfirmationResponses, SubmitResultDeviceConfirmationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/users/me/devices/confirmation/result',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Запустить скоринг-проверку
 *
 * Проверяет обе стороны договора: чёрный список (первым) и статус KYC. Решение: AUTO_APPROVE / MANUAL_REVIEW / REJECT с причинами. Требует право scoring.run.
 */
export const runScoring = <ThrowOnError extends boolean = false>(options: Options<RunScoringData, ThrowOnError>) => (options.client ?? client).post<RunScoringResponses, RunScoringErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/scoring/run',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Создать платёж service fee
 *
 * Создаёт платёж (INITIATED) и возвращает redirect/deeplink провайдера. provider в теле — выбранная кнопка платёжки (click | paynet | uzum | uzum-checkout); без него — провайдер по умолчанию (карточный флоу в приложении). Договор должен быть в AWAITING_FEE, вызывающий — плательщик по payment.fee.payer. Идемпотентно по договору: пока платёж INITIATED, выбор другой платёжки перепривязывает его; после PENDING возвращается фактический провайдер платежа. Требует право payment.initiate.
 */
export const initiatePayment = <ThrowOnError extends boolean = false>(options: Options<InitiatePaymentData, ThrowOnError>) => (options.client ?? client).post<InitiatePaymentResponses, InitiatePaymentErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/payments',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Подтвердить карточную оплату кодом
 *
 * Проверяет СМС-код и завершает платёж: SUCCEEDED; когда все обязательные плательщики оплатили — Agreement AWAITING_FEE → AWAITING_DISBURSEMENT. Требует право payment.initiate.
 */
export const confirmPayment = <ThrowOnError extends boolean = false>(options: Options<ConfirmPaymentData, ThrowOnError>) => (options.client ?? client).post<ConfirmPaymentResponses, ConfirmPaymentErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/payments/{id}/confirm',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Запросить СМС-код карточной оплаты
 *
 * Отправляет СМС-код подтверждения оплаты на номер плательщика. Платёж должен быть активным (INITIATED/PENDING), вызывающий — его плательщик. Карточные данные на сервер не передаются. Повторный вызов — новый код (rate-limit по номеру и IP). Требует право payment.initiate.
 */
export const cardOtpPayment = <ThrowOnError extends boolean = false>(options: Options<CardOtpPaymentData, ThrowOnError>) => (options.client ?? client).post<CardOtpPaymentResponses, CardOtpPaymentErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/payments/{id}/card-otp',
    ...options
});

/**
 * Webhook платёжного провайдера
 *
 * Принимает уведомление об оплате (publicly reachable, вне JWT). Проверяет подпись, журналирует сырой payload, идемпотентно применяет статус. При SUCCEEDED доводит Agreement до AWAITING_DISBURSEMENT. Дубль/устаревшее/непривязанное событие — no-op (200).
 */
export const webhookPayment = <ThrowOnError extends boolean = false>(options: Options<WebhookPaymentData, ThrowOnError>) => (options.client ?? client).post<WebhookPaymentResponses, WebhookPaymentErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/payments/webhook/{provider}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Uzum status (Merchant API)
 *
 * Вебхук Uzum Bank Merchant API (publicly reachable, вне JWT; Basic-auth по payment.uzum.username/password, allowlist payment.uzum.allowed.cidrs). Платёж находится по params.payment_code. Отказ — HTTP 400 с status FAILED и errorCode протокола Uzum.
 */
export const statusUzum = <ThrowOnError extends boolean = false>(options?: Options<StatusUzumData, ThrowOnError>) => (options?.client ?? client).post<StatusUzumResponses, StatusUzumErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/payments/uzum/status',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Uzum reverse (Merchant API)
 *
 * Вебхук Uzum Bank Merchant API (publicly reachable, вне JWT; Basic-auth по payment.uzum.username/password, allowlist payment.uzum.allowed.cidrs). Платёж находится по params.payment_code. Отказ — HTTP 400 с status FAILED и errorCode протокола Uzum.
 */
export const reverseUzum = <ThrowOnError extends boolean = false>(options?: Options<ReverseUzumData, ThrowOnError>) => (options?.client ?? client).post<ReverseUzumResponses, ReverseUzumErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/payments/uzum/reverse',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Uzum create (Merchant API)
 *
 * Вебхук Uzum Bank Merchant API (publicly reachable, вне JWT; Basic-auth по payment.uzum.username/password, allowlist payment.uzum.allowed.cidrs). Платёж находится по params.payment_code. Отказ — HTTP 400 с status FAILED и errorCode протокола Uzum.
 */
export const createUzum = <ThrowOnError extends boolean = false>(options?: Options<CreateUzumData, ThrowOnError>) => (options?.client ?? client).post<CreateUzumResponses, CreateUzumErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/payments/uzum/create',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Uzum confirm (Merchant API)
 *
 * Вебхук Uzum Bank Merchant API (publicly reachable, вне JWT; Basic-auth по payment.uzum.username/password, allowlist payment.uzum.allowed.cidrs). Платёж находится по params.payment_code. Отказ — HTTP 400 с status FAILED и errorCode протокола Uzum.
 */
export const confirmUzum = <ThrowOnError extends boolean = false>(options?: Options<ConfirmUzumData, ThrowOnError>) => (options?.client ?? client).post<ConfirmUzumResponses, ConfirmUzumErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/payments/uzum/confirm',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Uzum check (Merchant API)
 *
 * Вебхук Uzum Bank Merchant API (publicly reachable, вне JWT; Basic-auth по payment.uzum.username/password, allowlist payment.uzum.allowed.cidrs). Платёж находится по params.payment_code. Отказ — HTTP 400 с status FAILED и errorCode протокола Uzum.
 */
export const checkUzum = <ThrowOnError extends boolean = false>(options?: Options<CheckUzumData, ThrowOnError>) => (options?.client ?? client).post<CheckUzumResponses, CheckUzumErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/payments/uzum/check',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * JSON-RPC веб-сервис поставщика Paynet
 *
 * Вызывается серверами Paynet (publicly reachable, вне JWT; Basic-auth по payment.paynet.username/password, allowlist payment.paynet.allowed.cidrs). Методы: GetInformation (справка по коду платежа), PerformTransaction (проведение: платёж SUCCEEDED, договор AWAITING_FEE → AWAITING_DISBURSEMENT), CheckTransaction, CancelTransaction (возврат, пока договор в AWAITING_FEE), GetStatement (сверка за период, GMT+5), ChangePassword. Ответ — всегда JSON-RPC 2.0: result либо error с кодом протокола Paynet.
 */
export const rpcPaynet = <ThrowOnError extends boolean = false>(options?: Options<RpcPaynetData, ThrowOnError>) => (options?.client ?? client).post<RpcPaynetResponses, RpcPaynetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/payments/paynet',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * CLICK Prepare (SHOP-API)
 *
 * Колбэк CLICK перед списанием (publicly reachable, вне JWT). Проверяет подпись sign_string, заказ (merchant_trans_id = order_id) и сумму; резервирует платёж (INITIATED → PENDING) и сохраняет click_trans_id. Ответ — всегда HTTP 200 с кодом результата в error (0 — успех, -1…-9 — отказ протокола).
 */
export const prepareClick = <ThrowOnError extends boolean = false>(options?: Options<PrepareClickData, ThrowOnError>) => (options?.client ?? client).post<PrepareClickResponses, unknown, ThrowOnError>({
    ...urlSearchParamsBodySerializer,
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/payments/click/prepare',
    ...options,
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        ...options?.headers
    }
});

/**
 * CLICK Complete (SHOP-API)
 *
 * Колбэк CLICK после списания (publicly reachable, вне JWT). Сверяет подпись и merchant_prepare_id; завершает платёж (SUCCEEDED; при отрицательном error от CLICK — FAILED). При успехе доводит Agreement до AWAITING_DISBURSEMENT. Ответ — всегда HTTP 200 с кодом результата в error.
 */
export const completeClick = <ThrowOnError extends boolean = false>(options?: Options<CompleteClickData, ThrowOnError>) => (options?.client ?? client).post<CompleteClickResponses, unknown, ThrowOnError>({
    ...urlSearchParamsBodySerializer,
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/payments/click/complete',
    ...options,
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        ...options?.headers
    }
});

/**
 * Delivery receipt провайдера уведомлений
 *
 * Принимает квитанцию о доставке (publicly reachable, вне JWT). Проверяет подпись, по providerMessageId переводит уведомление SENT→DELIVERED и пишет audit. Неизвестный/повторный идентификатор — no-op (200).
 */
export const receiptNotificationReceipt = <ThrowOnError extends boolean = false>(options: Options<ReceiptNotificationReceiptData, ThrowOnError>) => (options.client ?? client).post<ReceiptNotificationReceiptResponses, ReceiptNotificationReceiptErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/notifications/receipts/{provider}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Возразить против смены номера
 *
 * Возражение контрагента затронутого договора в течение срока возражения: запрос переходит в CONTESTED и эскалируется в поддержку. Идемпотентно по Idempotency-Key. Требует право msisdn.change.
 */
export const contestMsisdnChange = <ThrowOnError extends boolean = false>(options: Options<ContestMsisdnChangeData, ThrowOnError>) => (options.client ?? client).post<ContestMsisdnChangeResponses, ContestMsisdnChangeErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/msisdn-changes/{id}/contest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Подписать документ
 *
 * Подтверждает подпись через MyID (code из мобильного SDK, при активном MyID обязателен) и сохраняет артефакты (токен, fingerprint, KYC, ссылка на MyID-подтверждение, ts). Первая подпись → PARTIALLY_SIGNED; вторая → SIGNED и Agreement → AWAITING_FEE. Требует право contract.sign.
 */
export const signContract = <ThrowOnError extends boolean = false>(options: Options<SignContractData, ThrowOnError>) => (options.client ?? client).post<SignContractResponses, SignContractErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/contracts/{id}/sign',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Создать MyID-сессию подписи
 *
 * Создаёт сессию идентификации в MyID для подтверждения подписи: по reuid последней идентификации (без ввода документа), иначе по ПИНФЛ из профиля. Возвращает sessionId + clientHash/clientHashId для мобильного SDK. Доступно при активном настроенном MyID-провайдере. Требует право contract.sign и сторону договора.
 */
export const signSessionContract = <ThrowOnError extends boolean = false>(options: Options<SignSessionContractData, ThrowOnError>) => (options.client ?? client).post<SignSessionContractResponses, SignSessionContractErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/contracts/{id}/sign/session',
    ...options
});

/**
 * Отказаться подписывать
 *
 * Переводит документ в UNSIGNED, фиксирует отказавшегося, момент и причину (тело с reason опционально). Требует право contract.sign и сторону договора.
 */
export const declineSignContract = <ThrowOnError extends boolean = false>(options: Options<DeclineSignContractData, ThrowOnError>) => (options.client ?? client).post<DeclineSignContractResponses, DeclineSignContractErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/contracts/{id}/decline-sign',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Сопоставить контакты
 *
 * Принимает список телефонов и возвращает зарегистрированных пользователей Adolapp: только факт регистрации и verified, без PII. Невалидные и незарегистрированные номера в ответ не попадают. Требует право contact.read.
 */
export const matchContact = <ThrowOnError extends boolean = false>(options: Options<MatchContactData, ThrowOnError>) => (options.client ?? client).post<MatchContactResponses, MatchContactErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/contacts/match',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Пригласить контакт
 *
 * Отправляет SMS с deep link на номер, которого нет в Adolapp. Ограничено лимитом приглашений в час (по приглашающему и по номеру). Требует право contact.invite.
 */
export const inviteContact = <ThrowOnError extends boolean = false>(options: Options<InviteContactData, ThrowOnError>) => (options.client ?? client).post<InviteContactResponses, InviteContactErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/contacts/invite',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Обновление токенов (refresh rotation)
 *
 * Принимает текущий refresh + deviceId, отзывает старый refresh и выдаёт новую пару. Старый access продолжает работать до своего TTL (без серверной revocation).
 */
export const refreshAuth = <ThrowOnError extends boolean = false>(options: Options<RefreshAuthData, ThrowOnError>) => (options.client ?? client).post<RefreshAuthResponses, RefreshAuthErrors, ThrowOnError>({
    url: '/api/auth/refresh',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Верификация OTP
 *
 * Сверяет код, создаёт пользователя при первом входе, регистрирует устройство, выдаёт пару access+refresh и идентификатор устройства.
 */
export const verifyOtpAuth = <ThrowOnError extends boolean = false>(options: Options<VerifyOtpAuthData, ThrowOnError>) => (options.client ?? client).post<VerifyOtpAuthResponses, VerifyOtpAuthErrors, ThrowOnError>({
    url: '/api/auth/otp/verify',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Запрос OTP
 *
 * Нормализует телефон до E.164, генерирует и отправляет SMS-код. Повторный запрос для того же номера учитывает rate-limit и cooldown.
 */
export const requestOtpAuth = <ThrowOnError extends boolean = false>(options: Options<RequestOtpAuthData, ThrowOnError>) => (options.client ?? client).post<RequestOtpAuthResponses, RequestOtpAuthErrors, ThrowOnError>({
    url: '/api/auth/otp/request',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Logout (отзыв refresh + инвалидация сессии)
 *
 * Отзывает refresh-токен для указанного устройства и проставляет sessionInvalidatedAt — текущий access мгновенно перестаёт работать.
 */
export const logoutAuth = <ThrowOnError extends boolean = false>(options: Options<LogoutAuthData, ThrowOnError>) => (options.client ?? client).post<LogoutAuthResponses, LogoutAuthErrors, ThrowOnError>({
    url: '/api/auth/logout',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Список своих договоров
 *
 * Возвращает страницу договоров, где пользователь — сторона. Фильтры role/status опциональны. archived=false (по умолчанию) — договоры, не скрытые пользователем в архив; archived=true — только архив. Требует право agreement.read.
 */
export const listAgreement = <ThrowOnError extends boolean = false>(options?: Options<ListAgreementData, ThrowOnError>) => (options?.client ?? client).get<ListAgreementResponses, ListAgreementErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/agreements',
    ...options
});

/**
 * Создать черновик договора
 *
 * Создаёт договор в статусе DRAFT. Валюта всегда UZS; сумма проверяется по лимитам, дата возврата должна быть в будущем, самодоговор запрещён. Идемпотентно по Idempotency-Key. Требует право agreement.create.
 */
export const createAgreement = <ThrowOnError extends boolean = false>(options: Options<CreateAgreementData, ThrowOnError>) => (options.client ?? client).post<CreateAgreementResponses, CreateAgreementErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/agreements',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Отправить договор контрагенту
 *
 * Переводит DRAFT→SENT, запускает таймер ожидания ответа. Только инициатор. Требует право agreement.send.
 */
export const sendAgreement = <ThrowOnError extends boolean = false>(options: Options<SendAgreementData, ThrowOnError>) => (options.client ?? client).post<SendAgreementResponses, SendAgreementErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/agreements/{id}/send',
    ...options
});

/**
 * Создать допсоглашение о реструктуризации
 *
 * Создаёт документ-допсоглашение kind=AMENDMENT для переноса срока и/или частичного возврата. Применение условий происходит после подписания обеими сторонами через contract-sign flow. Требует право agreement.restructure.
 */
export const restructureAgreement = <ThrowOnError extends boolean = false>(options: Options<RestructureAgreementData, ThrowOnError>) => (options.client ?? client).post<RestructureAgreementResponses, RestructureAgreementErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/agreements/{id}/restructure',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Переподписать документ
 *
 * Подпись стороны в раунде переподписания после смены MSISDN. После подписей обеих сторон — новый PDF с актуальными реквизитами + новый хеш, документ → SIGNED. Требует право contract.sign.
 */
export const resignContract = <ThrowOnError extends boolean = false>(options: Options<ResignContractData, ThrowOnError>) => (options.client ?? client).post<ResignContractResponses, ResignContractErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/agreements/{id}/resign',
    ...options
});

/**
 * Подтвердить возврат
 *
 * Заёмщик инициирует погашение (→REPAYING); кредитор подтверждает (→CLOSED) с формированием расписки-PDF. Требует право transfer.repay.confirm.
 */
export const confirmRepaymentTransfer = <ThrowOnError extends boolean = false>(options: Options<ConfirmRepaymentTransferData, ThrowOnError>) => (options.client ?? client).post<ConfirmRepaymentTransferResponses, ConfirmRepaymentTransferErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/agreements/{id}/repayment-confirmations',
    ...options
});

/**
 * Загрузить пруф передачи
 *
 * Сохраняет файл пруфа в БД и привязывает к подтверждению этой стороны (kind). Загрузка опциональна. После закрытия договора (финальный статус) акты неизменяемы — 409 AGREEMENT_CLOSED. Требует право transfer.proof.upload.
 */
export const uploadProofTransfer = <ThrowOnError extends boolean = false>(options: Options<UploadProofTransferData, ThrowOnError>) => (options.client ?? client).post<UploadProofTransferResponses, UploadProofTransferErrors, ThrowOnError>({
    ...formDataBodySerializer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/agreements/{id}/proofs',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Загрузить пруф оплаты позиции графика
 *
 * Сохраняет файл пруфа в БД и привязывает к позиции графика (позиция должна быть отмечена оплаченной). Только заёмщик; загрузка опциональна. После закрытия договора (финальный статус) пруфы неизменяемы — 409 AGREEMENT_CLOSED. Файл — через GET /api/agreements/{id}/proofs/{proofFileId}. Требует право transfer.proof.upload.
 */
export const uploadProofInstallment = <ThrowOnError extends boolean = false>(options: Options<UploadProofInstallmentData, ThrowOnError>) => (options.client ?? client).post<UploadProofInstallmentResponses, UploadProofInstallmentErrors, ThrowOnError>({
    ...formDataBodySerializer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/agreements/{id}/installments/{seqNo}/proofs',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Подтвердить оплату позиции графика
 *
 * Заёмщик отмечает оплату очередной позиции (договор → REPAYING), кредитор подтверждает получение (остаток уменьшается, договор → ACTIVE; последняя позиция → CLOSED с распиской). Оплата строго по очереди. Требует право transfer.repay.confirm.
 */
export const confirmPaymentInstallment = <ThrowOnError extends boolean = false>(options: Options<ConfirmPaymentInstallmentData, ThrowOnError>) => (options.client ?? client).post<ConfirmPaymentInstallmentResponses, ConfirmPaymentInstallmentErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/agreements/{id}/installments/{seqNo}/payment-confirmations',
    ...options
});

/**
 * Споры договора
 *
 * Возвращает споры договора, если текущий пользователь — его сторона. Требует право dispute.read.
 */
export const byAgreementDispute = <ThrowOnError extends boolean = false>(options: Options<ByAgreementDisputeData, ThrowOnError>) => (options.client ?? client).get<ByAgreementDisputeResponses, ByAgreementDisputeErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/agreements/{id}/disputes',
    ...options
});

/**
 * Открыть спор
 *
 * Создаёт спор по договору в OVERDUE и переводит договор в DISPUTE. Только кредитор. Требует право dispute.open.
 */
export const openDispute = <ThrowOnError extends boolean = false>(options: Options<OpenDisputeData, ThrowOnError>) => (options.client ?? client).post<OpenDisputeResponses, OpenDisputeErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/agreements/{id}/disputes',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Подтвердить выдачу
 *
 * Кредитор «Я выдал» / заёмщик «Я получил». При обоих подтверждениях договор → ACTIVE. Договор должен быть в AWAITING_DISBURSEMENT. Требует право transfer.disburse.confirm.
 */
export const confirmDisbursementTransfer = <ThrowOnError extends boolean = false>(options: Options<ConfirmDisbursementTransferData, ThrowOnError>) => (options.client ?? client).post<ConfirmDisbursementTransferResponses, ConfirmDisbursementTransferErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/agreements/{id}/disbursement-confirmations',
    ...options
});

/**
 * Отклонить договор
 *
 * Переводит SENT→DECLINED с причиной. Только контрагент. Требует право agreement.decline.
 */
export const declineAgreement = <ThrowOnError extends boolean = false>(options: Options<DeclineAgreementData, ThrowOnError>) => (options.client ?? client).post<DeclineAgreementResponses, DeclineAgreementErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/agreements/{id}/decline',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Сгенерировать документ договора
 *
 * Формирует PDF из шаблона и хеш, создаёт документ в статусе GENERATED. Доступно стороне договора в статусе Agreement TERMS_LOCKED. Идемпотентно. Требует право contract.sign.
 */
export const generateContract = <ThrowOnError extends boolean = false>(options: Options<GenerateContractData, ThrowOnError>) => (options.client ?? client).post<GenerateContractResponses, GenerateContractErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/agreements/{id}/contract',
    ...options
});

/**
 * Отменить договор
 *
 * Переводит договор в CANCELLED (по матрице, до активации). Только инициатор. Требует право agreement.cancel.
 */
export const cancelAgreement = <ThrowOnError extends boolean = false>(options: Options<CancelAgreementData, ThrowOnError>) => (options.client ?? client).post<CancelAgreementResponses, CancelAgreementErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/agreements/{id}/cancel',
    ...options
});

/**
 * Вернуть договор из архива
 *
 * Снова показывает договор в списке текущей стороны. Идемпотентно. Требует право agreement.archive.
 */
export const unarchiveAgreement = <ThrowOnError extends boolean = false>(options: Options<UnarchiveAgreementData, ThrowOnError>) => (options.client ?? client).delete<UnarchiveAgreementResponses, UnarchiveAgreementErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/agreements/{id}/archive',
    ...options
});

/**
 * Архивировать договор
 *
 * Скрывает завершённый договор (CLOSED, CANCELLED, DECLINED, EXPIRED, NOT_DISBURSED) из списка текущей стороны; вторая сторона видит его как прежде. Архив доступен в списке с archived=true. Идемпотентно. Требует право agreement.archive.
 */
export const archiveAgreement = <ThrowOnError extends boolean = false>(options: Options<ArchiveAgreementData, ThrowOnError>) => (options.client ?? client).post<ArchiveAgreementResponses, ArchiveAgreementErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/agreements/{id}/archive',
    ...options
});

/**
 * Принять договор
 *
 * Переводит SENT→ACCEPTED, привязывает контрагента и стороны. Требует KYC=VERIFIED контрагента (иначе KYC_REQUIRED). Если обе стороны верифицированы — условия фиксируются (TERMS_LOCKED). Требует право agreement.accept.
 */
export const acceptAgreement = <ThrowOnError extends boolean = false>(options: Options<AcceptAgreementData, ThrowOnError>) => (options.client ?? client).post<AcceptAgreementResponses, AcceptAgreementErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/agreements/{id}/accept',
    ...options
});

/**
 * Список пользователей (страница)
 *
 * Возвращает страницу пользователей. Параметры: page, size, sort (например, sort=createdAt,desc); phone — точечный поиск по номеру (любой формат, нормализуется в E.164); adminOnly=true — только пользователи, у которых есть право admin.access. Требует право users.read.
 */
export const listAdminUser = <ThrowOnError extends boolean = false>(options?: Options<ListAdminUserData, ThrowOnError>) => (options?.client ?? client).get<ListAdminUserResponses, ListAdminUserErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/users',
    ...options
});

/**
 * Создать пользователя с ролями
 *
 * Создаёт пользователя по телефону сразу с указанным набором ролей — основной сценарий: добавить сотрудника в админ-панель (одна из ролей должна нести admin.access). Телефон нормализуется в E.164. Требует права users.manage и users.roles.write.
 */
export const createAdminUser = <ThrowOnError extends boolean = false>(options: Options<CreateAdminUserData, ThrowOnError>) => (options.client ?? client).post<CreateAdminUserResponses, CreateAdminUserErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/users',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Override KYC (ручной VERIFIED)
 *
 * Принудительно переводит профиль пользователя в VERIFIED. Причина обязательна. Требует право kyc.override.
 */
export const overrideAdminKyc = <ThrowOnError extends boolean = false>(options: Options<OverrideAdminKycData, ThrowOnError>) => (options.client ?? client).post<OverrideAdminKycResponses, OverrideAdminKycErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/users/{userId}/kyc-override',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Админ-подтверждение устройства
 *
 * Снимает карантин с устройства без liveness — личность оператор проверяет вне системы, причина обязательна и попадает в аудит (DEVICE/KYC_CONFIRM_OVERRIDE). Требует право users.manage.
 */
export const confirmKycAdminDevice = <ThrowOnError extends boolean = false>(options: Options<ConfirmKycAdminDeviceData, ThrowOnError>) => (options.client ?? client).post<ConfirmKycAdminDeviceResponses, ConfirmKycAdminDeviceErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/users/{userId}/devices/{deviceId}/kyc-confirm',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Список ролей
 *
 * Возвращает все роли RBAC с плоским набором имён прав, отсортированные по имени. Требует право roles.read.
 */
export const listAdminRole = <ThrowOnError extends boolean = false>(options?: Options<ListAdminRoleData, ThrowOnError>) => (options?.client ?? client).get<ListAdminRoleResponses, ListAdminRoleErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/roles',
    ...options
});

/**
 * Создать роль
 *
 * Создаёт новую роль с набором прав. Имя — UPPER_SNAKE_CASE, уникальное по системе. Пустой набор прав допустим. Требует право roles.write.
 */
export const createAdminRole = <ThrowOnError extends boolean = false>(options: Options<CreateAdminRoleData, ThrowOnError>) => (options.client ?? client).post<CreateAdminRoleResponses, CreateAdminRoleErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/roles',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Возврат комиссии
 *
 * Переводит платёж SUCCEEDED→REFUNDED с обязательной причиной. Требует право payment.refund.
 */
export const refundAdminPayment = <ThrowOnError extends boolean = false>(options: Options<RefundAdminPaymentData, ThrowOnError>) => (options.client ?? client).post<RefundAdminPaymentResponses, RefundAdminPaymentErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/payments/{id}/refund',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Опубликовать новую версию оферты
 *
 * Загружает PDF и делает его активной версией; предыдущая деактивируется. Требует право settings.write.
 */
export const publishAdminOffer = <ThrowOnError extends boolean = false>(options?: Options<PublishAdminOfferData, ThrowOnError>) => (options?.client ?? client).post<PublishAdminOfferResponses, PublishAdminOfferErrors, ThrowOnError>({
    ...formDataBodySerializer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/offers',
    ...options,
    headers: {
        'Content-Type': null,
        ...options?.headers
    }
});

/**
 * Разрешить оспоренную смену номера
 *
 * Решение поддержки по запросу в CONTESTED: APPROVE — применить смену, REJECT — отклонить. Причина обязательна, действие фиксируется в аудите. Требует право msisdn.change.resolve.
 */
export const resolveAdminMsisdnChange = <ThrowOnError extends boolean = false>(options: Options<ResolveAdminMsisdnChangeData, ThrowOnError>) => (options.client ?? client).post<ResolveAdminMsisdnChangeResponses, ResolveAdminMsisdnChangeErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/msisdn-changes/{id}/resolve',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Отклонить KYC-заявку
 *
 * Переводит заявку в REJECTED и профиль пользователя в KYC_REJECTED. Причина обязательна. Требует право kyc.review.
 */
export const rejectAdminKyc = <ThrowOnError extends boolean = false>(options: Options<RejectAdminKycData, ThrowOnError>) => (options.client ?? client).post<RejectAdminKycResponses, RejectAdminKycErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/kyc/{id}/reject',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Подтвердить KYC-заявку
 *
 * Переводит заявку в APPROVED и профиль пользователя в VERIFIED. Причина обязательна. Требует право kyc.review.
 */
export const approveAdminKyc = <ThrowOnError extends boolean = false>(options: Options<ApproveAdminKycData, ThrowOnError>) => (options.client ?? client).post<ApproveAdminKycResponses, ApproveAdminKycErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/kyc/{id}/approve',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Опубликовать новую версию документа
 *
 * Загружает PDF документа типа kind (support-faq) как новую редакцию; предыдущая деактивируется. Требует право settings.write.
 */
export const publishAdminDocument = <ThrowOnError extends boolean = false>(options: Options<PublishAdminDocumentData, ThrowOnError>) => (options.client ?? client).post<PublishAdminDocumentResponses, PublishAdminDocumentErrors, ThrowOnError>({
    ...formDataBodySerializer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/documents/{kind}',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Сменить статус спора
 *
 * Переводит спор по матрице переходов с обязательной причиной; при ENFORCEMENT — договор DISPUTE→ENFORCEMENT, при SETTLED/DISMISSED — DISPUTE→CLOSED. Требует право dispute.manage.
 */
export const transitionAdminDispute = <ThrowOnError extends boolean = false>(options: Options<TransitionAdminDisputeData, ThrowOnError>) => (options.client ?? client).post<TransitionAdminDisputeResponses, TransitionAdminDisputeErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/disputes/{id}/transition',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Прикрепить артефакт спора
 *
 * Сохраняет файл артефакта (тип MEDIATED_AGREEMENT/NO_SETTLEMENT_CERT/AWARD/OTHER) в БД и привязывает к спору. Требует право dispute.manage.
 */
export const addArtifactAdminDispute = <ThrowOnError extends boolean = false>(options: Options<AddArtifactAdminDisputeData, ThrowOnError>) => (options.client ?? client).post<AddArtifactAdminDisputeResponses, AddArtifactAdminDisputeErrors, ThrowOnError>({
    ...formDataBodySerializer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/disputes/{id}/artifacts',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Список записей чёрного списка
 *
 * Возвращает страницу записей чёрного списка. Требует право scoring.run.
 */
export const listAdminBlacklist = <ThrowOnError extends boolean = false>(options?: Options<ListAdminBlacklistData, ThrowOnError>) => (options?.client ?? client).get<ListAdminBlacklistResponses, ListAdminBlacklistErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/blacklist',
    ...options
});

/**
 * Добавить запись в чёрный список
 *
 * Добавляет запись по ПИНФЛ и/или телефону с обязательной причиной; действие фиксируется в аудите. Требует право scoring.run.
 */
export const createAdminBlacklist = <ThrowOnError extends boolean = false>(options: Options<CreateAdminBlacklistData, ThrowOnError>) => (options.client ?? client).post<CreateAdminBlacklistResponses, CreateAdminBlacklistErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/blacklist',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Админ-отмена договора
 *
 * Переводит договор в CANCELLED (по матрице) с обязательной причиной. Требует право agreement.cancel.admin.
 */
export const cancelAdminAgreement = <ThrowOnError extends boolean = false>(options: Options<CancelAdminAgreementData, ThrowOnError>) => (options.client ?? client).post<CancelAdminAgreementResponses, CancelAdminAgreementErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/agreements/{id}/cancel',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Настройки текущего пользователя
 *
 * Частичное обновление: acceptAgreementRequests — принимать ли запросы на договор (при false создание договора с этим пользователем как контрагентом даёт 409 COUNTERPARTY_NOT_ACCEPTING_REQUESTS); pushEnabled — push-уведомления (при false уведомления только во входящих приложения, без push и SMS-замены). Поля со значением null не меняются. Требует право profile.write.
 */
export const updateSettingsUser = <ThrowOnError extends boolean = false>(options: Options<UpdateSettingsUserData, ThrowOnError>) => (options.client ?? client).patch<UpdateSettingsUserResponses, UpdateSettingsUserErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/users/me/settings',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Карточка пользователя
 *
 * Возвращает пользователя по id с именами ролей и флагом enabled. Требует право users.read.
 */
export const getAdminUser = <ThrowOnError extends boolean = false>(options: Options<GetAdminUserData, ThrowOnError>) => (options.client ?? client).get<GetAdminUserResponses, GetAdminUserErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/users/{id}',
    ...options
});

/**
 * Изменить статус пользователя
 *
 * Включает или отключает пользователя (логический бан/разбан). Изменение действует немедленно. Требует право users.manage.
 */
export const updateStatusAdminUser = <ThrowOnError extends boolean = false>(options: Options<UpdateStatusAdminUserData, ThrowOnError>) => (options.client ?? client).patch<UpdateStatusAdminUserResponses, UpdateStatusAdminUserErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/users/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Профиль текущего пользователя
 *
 * Возвращает профиль (id, телефон, роли, плоский список permissions, метаданные). Поле permissions клиент использует для скрытия/показа разделов UI. Требует право profile.read.
 */
export const meUser = <ThrowOnError extends boolean = false>(options?: Options<MeUserData, ThrowOnError>) => (options?.client ?? client).get<MeUserResponses, MeUserErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/users/me',
    ...options
});

/**
 * Профиль текущего пользователя
 *
 * Возвращает статус идентификации и распарсенные KYC-данные (ФИО/ПИНФЛ/дата рождения/паспорт). Требует право profile.read.
 */
export const meProfile = <ThrowOnError extends boolean = false>(options?: Options<MeProfileData, ThrowOnError>) => (options?.client ?? client).get<MeProfileResponses, MeProfileErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/users/me/profile',
    ...options
});

/**
 * Описание рейтинга
 *
 * Локализованные заголовок и текст экрана «Что такое рейтинг» из настроек profile.rating.info.<locale>.title|body; локаль — параметр locale, затем локаль пользователя, затем дефолтная. Требует право profile.read.
 */
export const ratingInfoProfile = <ThrowOnError extends boolean = false>(options?: Options<RatingInfoProfileData, ThrowOnError>) => (options?.client ?? client).get<RatingInfoProfileResponses, RatingInfoProfileErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/users/me/profile/rating-info',
    ...options
});

/**
 * Мои акцептованные версии оферты
 *
 * Версии, которые пользователь акцептовал при входе (новые сверху): номер, SHA-256, момент акцепта и публикации, признак действующей версии и fileUrl для PDF. Требует право profile.read.
 */
export const listMineOfferAcceptance = <ThrowOnError extends boolean = false>(options?: Options<ListMineOfferAcceptanceData, ThrowOnError>) => (options?.client ?? client).get<ListMineOfferAcceptanceResponses, ListMineOfferAcceptanceErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/users/me/offers',
    ...options
});

/**
 * PDF версии оферты
 *
 * Документ версии (inline PDF): активная доступна любому авторизованному, архивная — только акцептовавшему. Требует право profile.read.
 */
export const versionFileOfferAcceptance = <ThrowOnError extends boolean = false>(options: Options<VersionFileOfferAcceptanceData, ThrowOnError>) => (options.client ?? client).get<VersionFileOfferAcceptanceResponses, VersionFileOfferAcceptanceErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/users/me/offers/{version}/file',
    ...options
});

/**
 * Список уведомлений
 *
 * Возвращает страницу уведомлений текущего пользователя (новые первыми). Фильтры: ALL — все, UNREAD — непрочитанные, AGREEMENTS — связанные с договорами. Требует право notification.read.
 */
export const listNotification = <ThrowOnError extends boolean = false>(options?: Options<ListNotificationData, ThrowOnError>) => (options?.client ?? client).get<ListNotificationResponses, ListNotificationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/users/me/notifications',
    ...options
});

/**
 * Отменить запрос смены номера
 *
 * Переводит активный запрос в CANCELLED (до применения смены); заморозка снимается. Идемпотентно по Idempotency-Key. Требует право msisdn.change.
 */
export const cancelMsisdnChange = <ThrowOnError extends boolean = false>(options: Options<CancelMsisdnChangeData, ThrowOnError>) => (options.client ?? client).delete<CancelMsisdnChangeResponses, CancelMsisdnChangeErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/users/me/msisdn-changes/{id}',
    ...options
});

/**
 * Статус запроса смены номера
 *
 * Текущий статус, затронутые договоры с классификацией действий и дедлайн возражения. Требует право msisdn.change.read.
 */
export const getMsisdnChange = <ThrowOnError extends boolean = false>(options: Options<GetMsisdnChangeData, ThrowOnError>) => (options.client ?? client).get<GetMsisdnChangeResponses, GetMsisdnChangeErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/users/me/msisdn-changes/{id}',
    ...options
});

/**
 * Активные устройства
 *
 * Возвращает только не-отозванные устройства текущего пользователя. Требует право device.read.
 */
export const listDevice = <ThrowOnError extends boolean = false>(options?: Options<ListDeviceData, ThrowOnError>) => (options?.client ?? client).get<ListDeviceResponses, ListDeviceErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/users/me/devices',
    ...options
});

/**
 * Карточка платежа
 *
 * Возвращает статус и реквизиты платежа. Сторона — по payment.read, стафф — по payment.read.all.
 */
export const getPayment = <ThrowOnError extends boolean = false>(options: Options<GetPaymentData, ThrowOnError>) => (options.client ?? client).get<GetPaymentResponses, GetPaymentErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/payments/{id}',
    ...options
});

/**
 * Активная версия оферты
 *
 * Метаданные активной версии: номер, SHA-256 PDF, дата публикации. Публичный. С access-токеном в ответе дополнительно signedByViewer.
 */
export const currentOffer = <ThrowOnError extends boolean = false>(options?: Options<CurrentOfferData, ThrowOnError>) => (options?.client ?? client).get<CurrentOfferResponses, CurrentOfferErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/offers/current',
    ...options
});

/**
 * PDF активной версии оферты
 *
 * Сам документ (inline PDF). Публичный.
 */
export const currentFileOffer = <ThrowOnError extends boolean = false>(options?: Options<CurrentFileOfferData, ThrowOnError>) => (options?.client ?? client).get<CurrentFileOfferResponses, CurrentFileOfferErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/offers/current/file',
    ...options
});

/**
 * Метаданные документа
 *
 * Тип, номер редакции, SHA-256 PDF и дата публикации текущей редакции. Публичный. Типы: support-faq.
 */
export const getDocument = <ThrowOnError extends boolean = false>(options: Options<GetDocumentData, ThrowOnError>) => (options.client ?? client).get<GetDocumentResponses, GetDocumentErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/documents/{kind}',
    ...options
});

/**
 * PDF документа
 *
 * Сам документ (inline PDF). Публичный.
 */
export const fileDocument = <ThrowOnError extends boolean = false>(options: Options<FileDocumentData, ThrowOnError>) => (options.client ?? client).get<FileDocumentResponses, FileDocumentErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/documents/{kind}/file',
    ...options
});

/**
 * Карточка спора
 *
 * Возвращает спор, если текущий пользователь — сторона его договора. Требует право dispute.read.
 */
export const getDispute = <ThrowOnError extends boolean = false>(options: Options<GetDisputeData, ThrowOnError>) => (options.client ?? client).get<GetDisputeResponses, GetDisputeErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/disputes/{id}',
    ...options
});

/**
 * Карточка документа договора
 *
 * Возвращает метаданные документа и хеш PDF. Сторона — по contract.read, стафф — по agreement.read.all.
 */
export const getContract = <ThrowOnError extends boolean = false>(options: Options<GetContractData, ThrowOnError>) => (options.client ?? client).get<GetContractResponses, GetContractErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/contracts/{id}',
    ...options
});

/**
 * Скачать PDF документа
 *
 * Отдаёт байты PDF из БД (авторизованная отдача, без presigned-URL). Сторона — по contract.read, стафф — по agreement.read.all.
 */
export const pdfContract = <ThrowOnError extends boolean = false>(options: Options<PdfContractData, ThrowOnError>) => (options.client ?? client).get<PdfContractResponses, PdfContractErrors, ThrowOnError>({
    responseType: 'blob',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/contracts/{id}/pdf',
    ...options
});

/**
 * Карточка контакта
 *
 * Возвращает публичные поля контакта (телефон, verified, маскированные ФИО и ПИНФЛ, аватар, score) и договоры между текущим пользователем и контактом (party-check). Требует право contact.read.
 */
export const cardContact = <ThrowOnError extends boolean = false>(options: Options<CardContactData, ThrowOnError>) => (options.client ?? client).get<CardContactResponses, CardContactErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/contacts/{userId}',
    ...options
});

/**
 * Ссылка-приглашение
 *
 * Возвращает диплинк-приглашение с атрибуцией пригласившего (ref) для системного share — без отправки SMS. Номер валидируется и проверяется на отсутствие в Adolapp. Требует право contact.invite.
 */
export const inviteLinkContact = <ThrowOnError extends boolean = false>(options: Options<InviteLinkContactData, ThrowOnError>) => (options.client ?? client).get<InviteLinkContactResponses, InviteLinkContactErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/contacts/invite-link',
    ...options
});

/**
 * Аватар пользователя
 *
 * Отдаёт JPEG аватара по avatarFileId из профиля, контактов или карточки договора. Ответ неизменяемый (Cache-Control: private, max-age=1 год, immutable) — новый аватар получает новый идентификатор. Любой авторизованный пользователь.
 */
export const getAvatar = <ThrowOnError extends boolean = false>(options: Options<GetAvatarData, ThrowOnError>) => (options.client ?? client).get<GetAvatarResponses, GetAvatarErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/avatars/{fileId}',
    ...options
});

/**
 * Конфиг приложения при запуске
 *
 * Политика обновления: minVersion (ниже неё любой запрос к API отвечает 426 UPGRADE_REQUIRED), recommendedVersion (ниже неё — предложить обновиться), ссылка на стор и текст. Платформа — параметр platform или заголовок X-App-Platform; версия клиента — заголовок X-App-Version. Без токена.
 */
export const configAppConfig = <ThrowOnError extends boolean = false>(options?: Options<ConfigAppConfigData, ThrowOnError>) => (options?.client ?? client).get<ConfigAppConfigResponses, ConfigAppConfigErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/app/config',
    ...options
});

/**
 * Удалить договор
 *
 * Мягкое удаление до подписания обеими сторонами: договор в DRAFT/SENT/ACCEPTED/TERMS_LOCKED отменяется (контрагент уведомляется как при отмене), затем скрывается в архив инициатора; запрос в DECLINED/EXPIRED/CANCELLED просто уходит в архив. Физически ничего не удаляется: договор остаётся в аудите, у второй стороны и в админке. Только инициатор. Требует право agreement.cancel.
 */
export const deleteAgreement = <ThrowOnError extends boolean = false>(options: Options<DeleteAgreementData, ThrowOnError>) => (options.client ?? client).delete<DeleteAgreementResponses, DeleteAgreementErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/agreements/{id}',
    ...options
});

/**
 * Карточка договора
 *
 * Возвращает договор, если текущий пользователь — его сторона. Требует право agreement.read.
 */
export const getAgreement = <ThrowOnError extends boolean = false>(options: Options<GetAgreementData, ThrowOnError>) => (options.client ?? client).get<GetAgreementResponses, GetAgreementErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/agreements/{id}',
    ...options
});

/**
 * Сводка по передаче
 *
 * Возвращает подтверждения с метаданными пруфов, статус договора и хеш расписки. Сторона — по agreement.read, стафф — по agreement.read.all.
 */
export const transfersTransfer = <ThrowOnError extends boolean = false>(options: Options<TransfersTransferData, ThrowOnError>) => (options.client ?? client).get<TransfersTransferResponses, TransfersTransferErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/agreements/{id}/transfers',
    ...options
});

/**
 * Состояние переподписания
 *
 * Кто подписал в текущем раунде переподписания, чья подпись ожидается и дедлайн. Требует право contract.read.
 */
export const resignStatusContract = <ThrowOnError extends boolean = false>(options: Options<ResignStatusContractData, ThrowOnError>) => (options.client ?? client).get<ResignStatusContractResponses, ResignStatusContractErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/agreements/{id}/resign-status',
    ...options
});

/**
 * Скачать пруф передачи
 *
 * Отдаёт байты пруфа из БД (авторизованная отдача). Сторона — по agreement.read, стафф — по agreement.read.all.
 */
export const proofTransfer = <ThrowOnError extends boolean = false>(options: Options<ProofTransferData, ThrowOnError>) => (options.client ?? client).get<ProofTransferResponses, ProofTransferErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/agreements/{id}/proofs/{proofId}',
    ...options
});

/**
 * График платежей
 *
 * Позиции графика рассрочки со статусами и сводкой по договору (пусто для договора типа LOAN). Требует право agreement.read и сторону договора.
 */
export const scheduleInstallment = <ThrowOnError extends boolean = false>(options: Options<ScheduleInstallmentData, ThrowOnError>) => (options.client ?? client).get<ScheduleInstallmentResponses, ScheduleInstallmentErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/agreements/{id}/installments',
    ...options
});

/**
 * Предпросмотр документа договора
 *
 * Рендерит PDF договора по текущему шаблону и условиям — с момента создания черновика, ещё до принятия запроса второй стороной. Ничего не сохраняет: ни документа, ни хеша, ни печати. Реквизиты стороны подставляются только после её принятия запроса и подтверждения личности, иначе — прочерк; дата документа — прочерк. Доступно, пока документ не сформирован (в карточке договора contractId = null); затем — 409 CONTRACT_ALREADY_GENERATED, читайте GET /api/contracts/{contractId}/pdf. Сторона (в том числе приглашённый контрагент по телефону) — по contract.read, стафф — по agreement.read.all.
 */
export const previewContract = <ThrowOnError extends boolean = false>(options: Options<PreviewContractData, ThrowOnError>) => (options.client ?? client).get<PreviewContractResponses, PreviewContractErrors, ThrowOnError>({
    responseType: 'blob',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/agreements/{id}/contract/preview',
    ...options
});

/**
 * Итоговые суммы долга
 *
 * Возвращает суммарный остаток тела займа и число договоров отдельно для роли заёмщика («Ваш долг») и кредитора («Вам должны»). Учитываются только договоры с переданными деньгами и незавершённым возвратом: ACTIVE, REPAYING, OVERDUE, DISPUTE, ENFORCEMENT. Проценты и штрафы в суммы не входят. Требует право agreement.read.
 */
export const totalsAgreement = <ThrowOnError extends boolean = false>(options?: Options<TotalsAgreementData, ThrowOnError>) => (options?.client ?? client).get<TotalsAgreementResponses, TotalsAgreementErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/agreements/totals',
    ...options
});

/**
 * Статусы договора и переходы
 *
 * Возвращает все статусы AgreementStatus и допустимые из каждого переходы. Доступно любому авторизованному пользователю.
 */
export const statusesAgreement = <ThrowOnError extends boolean = false>(options?: Options<StatusesAgreementData, ThrowOnError>) => (options?.client ?? client).get<StatusesAgreementResponses, StatusesAgreementErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/agreements/statuses',
    ...options
});

/**
 * Расчёт service fee по тарифной сетке
 *
 * Возвращает комиссию платформы для типа договора и суммы тела займа (тийины) по тарифной сетке. Значение справочное для формы создания: окончательная комиссия фиксируется на договоре при завершении подписания (feeAmountTiyin в карточке). Доступно любому авторизованному пользователю.
 */
export const feeQuoteAgreement = <ThrowOnError extends boolean = false>(options: Options<FeeQuoteAgreementData, ThrowOnError>) => (options.client ?? client).get<FeeQuoteAgreementResponses, FeeQuoteAgreementErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/agreements/fee-quote',
    ...options
});

/**
 * Параметры создания договора
 *
 * Возвращает лимиты суммы (тийины), срок ожидания ответа контрагента и параметры service fee (сумма, плательщик) из настроек. Клиент рисует форму создания по ним. Доступно любому авторизованному пользователю.
 */
export const configAgreement = <ThrowOnError extends boolean = false>(options?: Options<ConfigAgreementData, ThrowOnError>) => (options?.client ?? client).get<ConfigAgreementResponses, ConfigAgreementErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/agreements/config',
    ...options
});

/**
 * Устройства пользователя
 *
 * Все устройства пользователя (включая отозванные) со служебными полями карантина: kycConfirmedAt (null = не подтверждено), kycConfirmAttempts, revoked. Требует право users.read.
 */
export const listDevicesAdminDevice = <ThrowOnError extends boolean = false>(options: Options<ListDevicesAdminDeviceData, ThrowOnError>) => (options.client ?? client).get<ListDevicesAdminDeviceResponses, ListDevicesAdminDeviceErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/users/{userId}/devices',
    ...options
});

/**
 * Список настроек
 *
 * Возвращает все бизнес-настройки из БД (key/value/type/description), отсортированные по ключу. Требует право settings.read.
 */
export const listSettings = <ThrowOnError extends boolean = false>(options?: Options<ListSettingsData, ThrowOnError>) => (options?.client ?? client).get<ListSettingsResponses, ListSettingsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/settings',
    ...options
});

/**
 * Список прав
 *
 * Возвращает все права RBAC, отсортированные по имени. Требует право permissions.read.
 */
export const listAdminPermission = <ThrowOnError extends boolean = false>(options?: Options<ListAdminPermissionData, ThrowOnError>) => (options?.client ?? client).get<ListAdminPermissionResponses, ListAdminPermissionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/permissions',
    ...options
});

/**
 * Поиск платежей
 *
 * Возвращает страницу платежей с фильтром status. Требует право payment.read.all.
 */
export const searchAdminPayment = <ThrowOnError extends boolean = false>(options?: Options<SearchAdminPaymentData, ThrowOnError>) => (options?.client ?? client).get<SearchAdminPaymentResponses, SearchAdminPaymentErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/payments',
    ...options
});

/**
 * Метрики за период
 *
 * Считает contracts_created, acceptance_rate, activation_rate, repaid_rate, overdue_rate, dispute_rate, repeat_usage_rate за период [from, to] (обе даты включительно, UTC). Требует право metrics.read.
 */
export const metricsAdminMetrics = <ThrowOnError extends boolean = false>(options: Options<MetricsAdminMetricsData, ThrowOnError>) => (options.client ?? client).get<MetricsAdminMetricsResponses, MetricsAdminMetricsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/metrics',
    ...options
});

/**
 * Очередь KYC-заявок
 *
 * Возвращает страницу заявок; с параметром status=PENDING — очередь ручной верификации. Требует право kyc.review.
 */
export const listAdminKyc = <ThrowOnError extends boolean = false>(options?: Options<ListAdminKycData, ThrowOnError>) => (options?.client ?? client).get<ListAdminKycResponses, ListAdminKycErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/kyc',
    ...options
});

/**
 * Выгрузить доказательный пакет по спору
 *
 * Собирает и отдаёт ZIP с договором, артефактами подписи, пруфами, артефактами спора, audit-цепочками и manifest.json (хеши + результат verifyChain). Требует право dispute.evidence.export.
 */
export const evidenceByDisputeAdminDispute = <ThrowOnError extends boolean = false>(options: Options<EvidenceByDisputeAdminDisputeData, ThrowOnError>) => (options.client ?? client).get<EvidenceByDisputeAdminDisputeResponses, EvidenceByDisputeAdminDisputeErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/disputes/{id}/evidence-package',
    ...options
});

/**
 * Журнал аудита по сущности
 *
 * Возвращает страницу событий по агрегату (entityType + entityId) в хронологическом порядке. Требует право audit.read.
 */
export const listAudit = <ThrowOnError extends boolean = false>(options?: Options<ListAuditData, ThrowOnError>) => (options?.client ?? client).get<ListAuditResponses, ListAuditErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/audit',
    ...options
});

/**
 * Поиск договоров
 *
 * Возвращает страницу договоров с фильтрами status и q (подстрока телефона контрагента). Требует право agreement.read.all.
 */
export const searchAdminAgreement = <ThrowOnError extends boolean = false>(options?: Options<SearchAdminAgreementData, ThrowOnError>) => (options?.client ?? client).get<SearchAdminAgreementResponses, SearchAdminAgreementErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/agreements',
    ...options
});

/**
 * Выгрузить доказательный пакет по договору
 *
 * Собирает и отдаёт ZIP с договором, артефактами подписи, пруфами, audit-цепочками и manifest.json (без артефактов спора). Требует право dispute.evidence.export.
 */
export const evidenceByAgreementAdminDispute = <ThrowOnError extends boolean = false>(options: Options<EvidenceByAgreementAdminDisputeData, ThrowOnError>) => (options.client ?? client).get<EvidenceByAgreementAdminDisputeResponses, EvidenceByAgreementAdminDisputeErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/agreements/{id}/evidence-package',
    ...options
});

/**
 * Сводная лента действий по договору
 *
 * Кто что подтвердил и когда: подтверждения выдачи/возврата по сторонам, позиции графика рассрочки с отметками, полный журнал аудита договора и связанных сущностей (документы, платежи, споры) в хронологическом порядке. Требует права agreement.read.all и audit.read.
 */
export const actionsAdminAgreement = <ThrowOnError extends boolean = false>(options: Options<ActionsAdminAgreementData, ThrowOnError>) => (options.client ?? client).get<ActionsAdminAgreementResponses, ActionsAdminAgreementErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/agreements/{id}/actions',
    ...options
});

/**
 * Отзыв устройства (logout на конкретном)
 *
 * Помечает устройство как revoked и инвалидирует его сессию — выпущенный access перестаёт работать мгновенно. Можно отзывать только свои устройства. Требует право device.revoke.
 */
export const revokeDevice = <ThrowOnError extends boolean = false>(options: Options<RevokeDeviceData, ThrowOnError>) => (options.client ?? client).delete<RevokeDeviceResponses, RevokeDeviceErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/users/me/devices/{id}',
    ...options
});

/**
 * Удалить аватар пользователя
 *
 * Убирает аватар из профиля и удаляет файл; причина обязательна и пишется в аудит. Идемпотентно. Требует право users.manage.
 */
export const removeAvatarAdminUser = <ThrowOnError extends boolean = false>(options: Options<RemoveAvatarAdminUserData, ThrowOnError>) => (options.client ?? client).delete<RemoveAvatarAdminUserResponses, RemoveAvatarAdminUserErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/users/{id}/avatar',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Удалить запись чёрного списка
 *
 * Удаляет запись по идентификатору; действие фиксируется в аудите. Требует право scoring.run.
 */
export const deleteAdminBlacklist = <ThrowOnError extends boolean = false>(options: Options<DeleteAdminBlacklistData, ThrowOnError>) => (options.client ?? client).delete<DeleteAdminBlacklistResponses, DeleteAdminBlacklistErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/blacklist/{id}',
    ...options
});
